import { createContext, useState, useContext, useMemo } from 'react';

import { Windows } from '@components/Window/windows';

const defaultState = { isOpen: false, type: null, props: null };

export const WindowContext = createContext({
  ...defaultState,
  actions: {
    open(type, props) {},
    close() {},
  },
});

export const useWindows = () => useContext(WindowContext);

const WindowManager = () => {
  const { isOpen, actions, type, props, key } = useWindows();
  const CurrentWindow = Windows[type];

  if (!CurrentWindow) {
    if (type) {
      console.error(`Unknown window: ${type}`);
    }
    return null;
  }

  return <CurrentWindow open={isOpen} onClose={actions.close} key={key} {...props} />;
};

export const WindowProvider = ({ children }) => {
  const [{ isOpen, type, props, key }, setState] = useState(defaultState);

  const actions = useMemo(
    () => ({
      open(type, props = {}) {
        setState({
          isOpen: true,
          key: new Date(),
          type,
          props,
        });
      },
      close() {
        setState(defaultState);
      },
    }),
    []
  );

  return (
    <WindowContext.Provider value={{ isOpen, type, props, actions, key }}>
      <WindowManager />
      {children}
    </WindowContext.Provider>
  );
};
